import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ProductService} from '../../../resources/services/product.service';
import {FormEntityExtension} from '../../../resources/extensions/form-entity-extension/form-entity.extension';
import {ValidateService} from '../../../resources/modules/validate/validate.service';
import {ToastrService} from 'ngx-toastr';
import {FormService} from '../../../resources/services/form.service';
import {MessageService} from '../../../resources/services/message.service';
import {Observable, Subscription} from 'rxjs';
import {FormEntityExtensionService} from "../../../resources/extensions/form-entity-extension/form-entity-extension.service";
import {MimeTypeConfig} from "../../../configs/mime-type.config";

@Component({
  selector: 'project-form',
  templateUrl: './project-form.component.html',
})
export class ProjectFormComponent extends FormEntityExtension implements OnInit, OnDestroy {

  projectLegacyDropzoneConfig: any = {
    addRemoveLinks: true,
    params: {},
  };

  acceptedFiles: string = MimeTypeConfig.zip;
  acceptedCovers: string = MimeTypeConfig.image;

  /**
   * отдельно от Extension,
   * чтобы конифг для ропзона использовать
   * @param value
   */
  @Input('data') set data$(value) {
    if (value) {
      this.data = value;
      this.projectLegacyDropzoneConfig.params.projectId = this.data?.id
    }
    this.patchValue();
  }

  constructor(protected formEntityExtensionService: FormEntityExtensionService,
              private _productService: ProductService,
              private formService: FormService) {
    super(formEntityExtensionService);

  }
  assetsForm: any;

  ngOnInit(): void {
    this.initForm(
      new FormBuilder().group({
        name: ['', Validators.required],
        active: [false],
        free: [false],
        availableForDownloading: [false],
        legacy: [false],
        // legacyId: [],
        store: [null, Validators.required],
        product: [],
        // assets: [],
        // subject: [null, Validators.required],
      })
    );
    this.initSubForm();
  }

  initSubForm() {

    this.assetsForm = {
      // legacyId: new FormControl(),
      assets: new FormControl(),
      covers: new FormControl()
    };

    this.initSubscription();
  }

  legacyChange$: Subscription;
  freeChange$: Subscription;

  initSubscription() {
    this.legacyChange$ = this.form.get('legacy').valueChanges.subscribe((result) => {
      if (this.data?.id)
        this.toggleByLegacy(result);
    });

    this.freeChange$ = this.form.get('free').valueChanges.subscribe((result) => {
      if (result) {
        this.form.get('availableForDownloading').setValue(true);
        this.form.get('availableForDownloading').disable();
      } else {
        this.form.get('availableForDownloading').enable();
      }
    });
  }


  toggleByLegacy(result: any) {
    this.formService.toggleControls(this.form, this.assetsForm, result === true);
  }

  ngOnDestroy() {
    this.legacyChange$.unsubscribe();
    this.freeChange$.unsubscribe();
  }

}
